import { inject, injectable } from 'inversify';
import { INotificationsCountService } from './notifications-count.interface';
import { INotificationsPoolService, NOTIFICATIONS_POOL_SERVICE } from '../notifications-pool';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@injectable()
export class NotificationsCountService implements INotificationsCountService {

    @inject(NOTIFICATIONS_POOL_SERVICE) private readonly notificationsPoolService: INotificationsPoolService;

    unreadCountObservable(): Observable<number> {

        return this.notificationsPoolService.notificationsPoolObservable()
            .pipe(
                map((notifications) => {
                    return notifications.filter(notif => !notif.haveBeenSeen).length;
                }),
            );
    }
}
